/**
 * Parse content_url from API — now a JSONB array, but handles legacy string
 * shapes (single URL or stringified JSON array) for backward compatibility.
 */
function parseContentUrlField(raw) {
  if (raw == null) return [];
  if (Array.isArray(raw)) {
    return raw.map((u) => String(u).trim()).filter(Boolean);
  }
  if (typeof raw === 'string') {
    const t = raw.trim();
    if (!t) return [];
    try {
      const parsed = JSON.parse(t);
      if (Array.isArray(parsed)) {
        return parsed.map((u) => String(u).trim()).filter(Boolean);
      }
    } catch {
      /* not JSON — treat as single URL */
    }
    return [t];
  }
  return [];
}

/**
 * Resolved list of post content URLs from a deliverable row.
 * Primary source: deliverable.content_url (JSONB array).
 * Falls back to collaboration-level content_url if the deliverable
 * object is missing or empty (e.g. legacy data pre-migration).
 */
function getPostContentUrls(deliverable, collaboration = null) {
  let d = deliverable;
  if (typeof d === 'string') {
    try {
      d = JSON.parse(d);
    } catch {
      return [];
    }
  }
  if (!d && !collaboration) return [];

  const fromDeliverable = parseContentUrlField(d?.content_url);
  if (fromDeliverable.length > 0) return fromDeliverable;

  const fromCollaboration = parseContentUrlField(collaboration?.content_url);
  if (fromCollaboration.length > 0) return fromCollaboration;

  return [];
}

/** True if at least one post content URL exists for this row. */
export function collaborationHasPostContentUrls(row) {
  if (!row) return false;
  return getPostContentUrls(row.deliverable, row).length > 0;
}

/** Legacy shape: content_posted flag OR any stored post URL. */
export function collaborationHasPostContent(row) {
  if (!row) return false;
  if (row.content_posted) return true;
  return collaborationHasPostContentUrls(row);
}

export default getPostContentUrls;
